import './elements'
import './woocommerce/user'

//Styles
import '../scss/main.scss'

var node = document.getElementById('my-node');

/*
htmlToImage.toPng(node)
    .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        document.body.appendChild(img);
    })
    .catch(function (error) {
        console.error('Oops, something went wrong!', error);
    });*/

//import images

if ('serviceWorker' in navigator && window.zggThemeSW) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(window.zggThemeSW, { scope: '/' }).then(registration => {
            console.log('SW registered: ', registration);
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    });
}